<template>
  <markdown-view-teacher :raw-text="formattedAnswer"></markdown-view-teacher>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { QUIZTYPE } from "@/consts/answer_column";
  import { normalizeNestedScript, separateBaselessScriptPair } from "@/util/remove_all";

  const props = defineProps<{
    /** 生徒の解答文字列 */
    answer: string;
    /** 解答形式（QUIZTYPE の値） */
    answerFormat: number;
    /** 教科分野（"rika" 形式、理科の場合にある特定の文字列の置換処理を行う） */
    subjectField?: string;
  }>();

  /**
   * 解答形式と教科分野に応じて生徒の解答をフォーマットする
   */
  const formattedAnswer = computed(() => {
    let formatted = props.answer;

    // NFR-3760 T9 学習進捗表　理科進捗表内「解答欄」にて、 生徒側で「2価以上のイオン式」を解答すると表示が崩れてしまう
    if (props.subjectField === "rika") {
      if (props.answerFormat === QUIZTYPE.DESCRIPTION || props.answerFormat === QUIZTYPE.WRITTEN_RANDOM_ORDER) {
        // 選択肢が記述式または順不問記述式の場合、mathjax形式の置換処理を行う
        formatted = formatted.replaceAll(/[\$](\\|[0-9]*)([A-Za-z])/g, "$\\rm $1$2");
      }
      if (formatted.length > 0) {
        // 理科でmathjax形式に下付き(_)、上付き(^)文字がある場合、置換処理を行う
        const isSubSup = (/\_|\^/g).test(formatted);
        if (isSubSup) {
          // NFR-7306 ネストした上付き/下付き（例 $Mg^{^2^+}$）を採点時と同様に正規化してから\ceで囲む
          formatted = normalizeNestedScript(formatted);
          // NFR-7419 ベースなしの上付き→下付き（例 $^+_2$）はmhchemが下付き優先に並べ替えるため、空グループ{}を挟んで入力順を保つ
          formatted = separateBaselessScriptPair(formatted);
          formatted = formatted.replace(/(\$)(.*?)(\$)/g, '$\\ce{$2}$');
        }
      }
    }

    // NFR-6198 順不同記述式の内部区切り「｜」を全角コンマ「、」に見せる
    if (props.answerFormat === QUIZTYPE.WRITTEN_RANDOM_ORDER) {
      formatted = formatted.replace(/｜/g, "、");
    }

    return formatted;
  });
</script>
